import React, { Component } from 'react';
import moment from 'moment';
import Calendar from '../components/Calendar';

const feriados = ['01/11/2017', '25/12/2017'];

const currentEvent = [
  {
  numProfVeh:'1345',  
  nomEmpresa: 'Empresa ya seleccionada',
  // si vas a editar una entrega
  fechProinicio: '17/11/2017 11:00',
  fechProfin: '17/11/2017 12:00',
  // si es nueva entrega
  // fechProinicio: '',
  // fechProfin: '',
  pedidos: [
    {
      numPedi: '12341232222222222223',
      chasis: 'asdasd',
    },
  ],
},
{
  numProfVeh:'1233',  
  nomEmpresa: 'Empresa ya seleccionada',
  // si vas a editar una entrega
  fechProinicio: '17/11/2017 11:00',
  fechProfin: '17/11/2017 12:00',
  // si es nueva entrega
  // fechProinicio: '',
  // fechProfin: '',
  pedidos: [
    {
      numPedi: '1234123412341234123',
      chasis: 'asdasd',
    },
  ],
}
];

// validar ficha proforma varias programas 

const eventosProgramados = [


  {
    numProfVeh:'1345',  
    nomEmpresa: 'Empresa ya seleccionada',
    // si vas a editar una entrega
    fechProinicio: '17/11/2017 11:00',
    fechProfin: '17/11/2017 12:00',
    // si es nueva entrega
    // fechProinicio: '',
    // fechProfin: '',
    pedidos: [
      {
        numPedi: '12341232222222222223',
        chasis: 'asdasd',
      },
    ],
  },
  {
    numProfVeh:'1233',  
    nomEmpresa: 'Empresa ya seleccionada',
    // si vas a editar una entrega
    fechProinicio: '17/11/2017 11:00',
    fechProfin: '17/11/2017 12:00',
    // si es nueva entrega
    // fechProinicio: '',
    // fechProfin: '',
    pedidos: [
      {
        numPedi: '1234123412341234123',
        chasis: 'asdasd',
      },
    ],
  },


  {
    numProfVeh:'1346',    
    nomEmpresa: 'CASTRO CUBA CONSTRUCTORES S.A.C.',
    fechProinicio: '16/11/2017 09:30',
    fechProfin: '16/11/2017 11:30',
    pedidos: [{ numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKTH086', chasis: '1C4RJEAG1FC109037' }, { numPedi: '15.WKJP161', chasis: '1C4RJFBG9FC171712' }] },
  {
    numProfVeh:'1347',        
    nomEmpresa: 'CASTRO CUBA CONSTRUCTORES S.A.C.',
    fechProinicio: '16/11/2017 09:30',
    fechProfin: '16/11/2017 11:30',
    pedidos: [{ numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKTH086', chasis: '1C4RJEAG1FC109037' }, { numPedi: '15.WKJP161', chasis: '1C4RJFBG9FC171712' }] },
  {
    numProfVeh:'1348',        
    nomEmpresa: 'AUTOMOTRIZ SAN BORJA S.A.C.',
    fechProinicio: '16/11/2017 11:00',
    fechProfin: '16/11/2017 13:00',
    pedidos: [{ numPedi: '15.22222222', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.33333333', chasis: '1C4RJFBG5FC149576' }] },
  {
    numProfVeh:'1348',        
    nomEmpresa: 'AUTOMOTRIZ SAN BORJA S.A.C.',
    fechProinicio: '16/11/2017 11:00',
    fechProfin: '16/11/2017 13:00',
    pedidos: [{ numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }] },
  {
    numProfVeh:'13410',        
    nomEmpresa: 'ANA SOFIA MATAYOSHI ARAGAKI',
    fechProinicio: '16/11/2017 16:30',
    fechProfin: '16/11/2017 18:30',
    pedidos: [{ numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKJP140', chasis: '1C4RJFBG5FC149576' }, { numPedi: '15.WKTH086', chasis: '1C4RJEAG1FC109037' }, { numPedi: '15.WKJP161', chasis: '1C4RJFBG9FC171712' }] },
];

class CalendarContainer extends Component {
  constructor(props) {
    super(props);

    this.updateParent = this.updateParent.bind(this);
    this.state = {
      selected: '',
      weekday: moment().weekday(),
      currentWeek: 0,
      eventosProgramados: [],
    };

    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
    this.today = this.today.bind(this);
  }

  updateParent(nuevoEvento, eventos) {
    console.log(nuevoEvento);
    this.setState({
      selected: nuevoEvento,
      eventosProgramados: eventos,
    });
  }

  back() {
    this.setState({ currentWeek: this.state.currentWeek - 1 });
  }

  next() {
    this.setState({ currentWeek: this.state.currentWeek + 1 });
  }

  today() {
    this.setState({ currentWeek: 0 });
  }

  render() {
    const { weekday, currentWeek } = this.state;
    const month = moment().add(currentWeek, 'weeks').format('MMMM - YYYY');
    const week = [];
    const date = [];
    for (let day = weekday; day > 0; day -= 1) {
      week.push(moment().subtract(day, 'days').add(currentWeek, 'weeks').format('DD/MM'));
      date.push(moment().subtract(day, 'days').add(currentWeek, 'weeks').format('DD/MM/YYYY'));
    }

    for (let day = 0; day < (7 - weekday); day += 1) {
      week.push(moment().add({
        days: day,
        weeks: currentWeek,
      }).format('DD/MM'));
      date.push(moment().add({
        days: day,
        weeks: currentWeek,
      }).format('DD/MM/YYYY'));
    }

    return (
      <div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='pag-arrows mt-3 mb-3 pull-right'>
              <a className='btn btn-default pag-link mr-2' onClick={() => this.today()}>Hoy</a>
              <a className='btn btn-default pag-link' onClick={() => this.back()}>
                <i className='ion-chevron-left' />
              </a>
              <a className='btn btn-default pag-link' onClick={() => this.next()}>
                <i className='ion-chevron-right' />
              </a>
            </div>
          </div>
          <div className='col-md-6'>
            <p>Empresa: {this.state.selected.nomEmpresa}</p>
            <p>Fecha: {this.state.selected.date}</p>
            <p>Hora inicio: {this.state.selected.from}</p>
            <p>Hora fin: {this.state.selected.to}</p>
            <p>Dia: {this.state.selected.day}</p>
            <button onClick={() => this.setState({ eventosProgramados })}>
              Agregar eventos programados
            </button>
          </div>
        </div>
        <Calendar
          horaInicio={'09:00'}
          horaFinal={'21:00'}
          horaExcepcion={['12:30','13:00']}
          asignacionFutura={1}
          rangoHora={1}
          eventosProgramados={this.state.eventosProgramados}
          slots={1} // max de eventos paralelos
          // events={events}
          updateParent={this.updateParent}
          weekday={this.state.weekday}
          week={week}
          date={date}
          month={month}
          currentEvent={currentEvent}
          feriados={feriados}
          maxEntregas={2}
          maxEntregasTipo='D' // dia o semana
        />
      </div>
    );
  }
}

export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/containers/CalendarContainer.js